<template>
   <div class="thank-you-header">
      <div class="container">
         <div class="content">
            <div class="tick-container">
               <div class="tick"></div>
            </div>

            <div v-if="alreadySwitched">
               <h1>Processing Switch</h1>
               <p>
                  Your switch has now been completed and is being processed by <b>{{ supplierName }}</b>.
                  <br />Please contact the supplier if you have any questions related to your new tariff
               </p>
            </div>

            <div v-else>
               <h1>Thank you</h1>
               <p>
                  Your switching application has been successfully submitted.
                  <br /> <b>{{ supplierName }}</b> will be in touch with you.
               </p>
            </div>

            <small>Reference Number</small>
            <p class="_margin-top-0 _margin-bottom-0">{{ referenceNumber }}</p>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   name: 'ThankYouHeader',
   props: {
      supplierName: String,
      referenceNumber: String,
      alreadySwitched: {
         type: Boolean,
         default: false
      }
   }
};
</script>

<style lang="scss">
.thank-you-header {
   background-color: $brand-colour-primary;
   padding: 40px 0 30px 0;
   margin: 0 0 30px 0;
   color: #000;

   h1 {
      font-size: 40px;
      margin: 0;
      line-height: 1.2;
      color: #fff;
      color: #fff;
      -webkit-text-fill-color: white;
      /* Will override color (regardless of order) */
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: black;
      letter-spacing: 0.5px;
   }

   p {
      font-size: 20px;
      color: #000;
   }

   .content {
      position: relative;
      padding: 0 0 0 115px;
   }

   .tick-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      height: 100px;
      background-color: darken($brand-colour-primary, 10%);
      border-radius: 50%;

      .tick {
         position: absolute;
         left: 0;
         top: 0;
         right: 0;
         bottom: 0;
         margin: auto;
         width: 32px;
         height: 24px;
         background: url('../../../assets/tick.png') no-repeat;
         background-size: contain;
         background-position: 100% 0;
      }
   }

   @media (max-width: 767px) {
      .content {
         position: relative;
         padding: 0 0 0 90px;
      }

      .tick-container {
         width: 70px;
         height: 70px;
      }
   }
}
</style>
